import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, styled, Grid, IconButton, Divider } from "@mui/material";
import dayjs from "dayjs";

import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import ButtonBlue from "../../../../shared/general/ButtonBlue";

import utils from "../../../../../../utils";

import DialogEdit from "./DialogEdit";

//Translator TH-EN
import { useTranslation } from "react-i18next";

const StyledWrapTop = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
  "& .MuiTypography-body2": {
    margin: 0,
  },
});

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledDivider = styled(Divider)({
  marginTop: 16,
  marginBottom: 16,
  borderWidth: "0px 0px thin",
  borderColor: "#919eab52",
  borderStyle: "dashed",
  width: "100%",
});

const StyledRoot = styled("div")({
  "& .salary": {
    "& .MuiTypography-h6": {
      marginRight: 8,
    },
    display: "flex",
    alignItems: "baseline",
  },
});

const SettingPayroll = (props) => {
  const { changeGroupTap, changeTabs } = props;
  const { t, i18n } = useTranslation();

  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: employeeProfile } = useSelector(
    (state) => state.employeeProfile
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [mode, setMode] = useState("");

  const handleClick = (mode) => {
    console.log("handleClick");
    setOpenDialog(true);
    setMode(mode);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const changeTimeToDate = (time) => {
    let splitTime = time.split(":");
    return new Date().setHours(splitTime[0], splitTime[1], splitTime[2]);
  };

  return (
    <StyledRoot>
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("SalaryPaymentSection")}
        </StyledHeadLabel>
        {!userProfile.readOnly && (
          <ButtonBlue
            variant="text"
            size="small"
            startIcon={<EditIcon />}
            // onClick={() => handleClick("cost")}
            onClick={() => {
              handleClick("payroll");
            }}
          >
            {t("EditData")}
          </ButtonBlue>
        )}
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("SalaryCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isNonPayroll ? `${t("No")}` : `${t("Yes")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />

      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("IncomeTaxSection")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("IncomeTaxCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isTax ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("socialSecurity")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("SocialSecurityCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isSso ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("ProvidentFund")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("ProvidentFundCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isPf ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("employeeWelfareFund")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("EmployeeWelfareFundCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isEWF ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("OvertimeSection")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("OTCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isOT ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>
      <StyledDivider />
      <StyledWrapTop>
        <StyledHeadLabel variant="body2" gutterBottom>
          {t("ShiftFeeSection")}
        </StyledHeadLabel>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div>
            <StyledHeadLabel color="text.secondary">
              {`${t("ShiftFeeCalculate")} ?`}
            </StyledHeadLabel>
            <Typography variant="h6">
              {employeeProfile.isShiftFee ? `${t("Yes")}` : `${t("No")}`}
            </Typography>
          </div>
        </Grid>
      </Grid>

      <DialogEdit
        mode={mode}
        open={openDialog}
        handleCloseDialog={handleCloseDialog}
      />
    </StyledRoot>
  );
};

export default SettingPayroll;
